<template>
    <div class="content">
        <h2>
            PRE-EXISTING MEDICAL CONDITION (PEC)
        </h2>
        <h4>
            A medical condition that has been in existence prior to the effective date
            of membership, with or without the Member's knowledge.
        </h4>
        <ul>
            <li>
                a.) There was the existence of symptoms which would cause an ordinarily
                prudent person to seek diagnosis, care or treatment.
            </li>
            <li>
                b.) The pathogenesis of such medical condition has been determined by an
                HMI PIC to have started prior to membership. Whether or not the member
                is aware of such illness or injury.
            </li>
        </ul>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.content {
  margin: auto;
  padding: 10px;
}
.content h2 {
  font-size: 16px;
  text-align: justify;
  color: #1b5e20;
}
.content h4 {
  font-weight: normal;
  font-size: 13px;
  text-align: justify;
  padding-left: 10px;
}
.content ul li {
  font-size: 13px;
  color: black;
  margin-top: 10px;
  list-style: none;
  text-align: justify;
}
@media (max-width: 599px) {
  .content {
    width: 90%;
    margin-top: 10px;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .content {
   
    width: 80%;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  .content {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .content {
    width: 100%;
  }
}
</style>
